module.exports = __webpack_public_path__ + "static/media/img-9.b55a1457.jpg";